import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { appConfig } from '../../config'
// import { google } from 'googleapis'

import * as config from '../../config'

// const credentials = config.serviceAccount
const baseUrl = 'https://sheets.googleapis.com/v4/spreadsheets'
const spreadsheetID = '1sHsujATLer3dpndeQmCY3BmwqbPbSdPwdro9x_wax-I'
const billingSheet = '\'Support Monthly Billing\'!A1:ZZZ'
const trackerSheet = '\'Support SP Tracker\'!A1:ZZZ'
const ticketsSheet = '\'Tickets Per Sprint\'!A1:ZZZ'

export const fetchSpreadsheet = createAsyncThunk(
  'google/fetchSpreadsheet',
  async (arg, { rejectWithValue }) => {
    try {
      const billingUrl = `${baseUrl}/${spreadsheetID}/values/${billingSheet}?key=${appConfig.googleAPIKey}`
      const trackerUrl = `${baseUrl}/${spreadsheetID}/values/${trackerSheet}?key=${appConfig.googleAPIKey}`
      const ticketsMonthlyUrl = `${baseUrl}/${spreadsheetID}/values/${ticketsSheet}?key=${appConfig.googleAPIKey}`

      const [
        billingResponse, trackerResponse, ticketsMonthlyResponse
      ] = await Promise.all([axios.get(billingUrl), axios.get(trackerUrl), axios.get(ticketsMonthlyUrl)])

      const results = {}

      if (
        typeof billingResponse === 'object' && Boolean(billingResponse) && typeof billingResponse.data === 'object' && Boolean(billingResponse.data.values)
      ) {
        results.billingInfo = dissectSheet(billingResponse, 'billing')
      }

      if (
        typeof trackerResponse === 'object' && Boolean(trackerResponse) && typeof trackerResponse.data === 'object' && Boolean(trackerResponse.data.values)
      ) {
        results.trackerInfo = dissectSheet(trackerResponse, 'tracker')
      }

      if (
        typeof ticketsMonthlyResponse === 'object' && Boolean(ticketsMonthlyResponse) && typeof ticketsMonthlyResponse.data === 'object' && Boolean(ticketsMonthlyResponse.data.values)
      ) {
        results.ticketsInfo = dissectSheet(ticketsMonthlyResponse, 'ticketsMonthly')
      }

      return results
    } catch (err) {
      console.error(err)
      return rejectWithValue(false)
    }
  },
  {
    condition: (arg, { getState }) => {
      // Cache: don't refetch if we already have data during this session,
      // unless explicitly forced (page refresh clears this slice anyway).
      if (arg?.force) return true

      const state = getState()?.google || {}
      if (state.loading) return false

      const hasBilling = state.billingInfo && Object.keys(state.billingInfo).length > 0
      const hasTracker = state.trackerInfo && Object.keys(state.trackerInfo).length > 0
      const hasTickets = state.ticketsInfo && Object.keys(state.ticketsInfo).length > 0

      return !(hasBilling && hasTracker && hasTickets)
    }
  }
)

const dissectSheet = (response, type) => {
  if (typeof response !== 'object' || !response || !type) {
    throw new Error('Failed to dissect sheet')
  }

  const [spreadsheetHeaders, spreadsheetData] = (() => {
    switch (type) {
      case 'billing': {
        const [billingHeaders, ...billingData] = response.data.values

        if (Array.isArray(billingHeaders) && Boolean(billingHeaders.length)) {
          return [billingHeaders, billingData]
        }

        return [false, false]
      }
      case 'tracker': {
        const [, trackerSprints, ...trackerData] = response.data.values

        if (Array.isArray(trackerSprints) && Boolean(trackerSprints.length)) {
          return [trackerSprints, trackerData]
        }

        return [false, false]
      }
      case 'ticketsMonthly': {
        const [, ticketsSprints, ...ticketsData] = response.data.values

        if (Array.isArray(ticketsSprints) && Boolean(ticketsSprints.length)) {
          return [ticketsSprints, ticketsData]
        }

        return [false, false]
      }
      default: break
    }
  })()

  if (!spreadsheetHeaders || !spreadsheetData) { throw new Error('Failed to dissect headers or data') }

  const dissectedInfo = spreadsheetData.reduce((obj, rowArrs) => {
    if (Array.isArray(rowArrs) && Boolean(rowArrs.length)) {
      const [sampClientName, ...rowData] = rowArrs
      const clientName = (sampClientName || '').trim().replace(/^"+|"+$/g, '')

      if (Boolean(clientName) && typeof clientName === 'string' && !obj[clientName] && clientName !== 'TOTAL') {
        obj[clientName] = rowData.reduce((arr, rowInfo, rowIndex) => {
          if (typeof rowInfo === 'string' && Boolean(rowInfo)) {
            const header = spreadsheetHeaders[rowIndex + 1]

            switch (type) {
              case 'billing': {
                const value = Number(rowInfo.replace('$', '').replace(/,/g, ''))

                const dateObj = new Date(header)
                const [startDate] = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1).toISOString().split('T')
                const [endDate] = new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0).toISOString().split('T')

                arr.push({
                  startDate,
                  endDate,
                  value
                })
                break
              }
              case 'tracker': {
                const value = rowInfo !== '-' ? Number(rowInfo) : 0
                const sprintInfo = config.sprintsJson[header]

                if (typeof sprintInfo === 'object' && Boolean(sprintInfo)) {
                  const startDateObj = new Date(sprintInfo.startDate)
                  const endDateObj = new Date(sprintInfo.endDate)
                  const [startDate] = new Date(startDateObj).toISOString().split('T')
                  const [endDate] = new Date(endDateObj).toISOString().split('T')

                  arr.push({
                    sprintName: sprintInfo.sprintName,
                    startDate,
                    endDate,
                    value
                  })
                }

                break
              }
              case 'ticketsMonthly': {
                const value = rowInfo !== '0' && Number(rowInfo) !== 0 ? rowInfo.split(',').length : 0
                const sprintInfo = config.sprintsJson[header]

                if (typeof sprintInfo === 'object' && Boolean(sprintInfo)) {
                  const startDateObj = new Date(sprintInfo.startDate)
                  const endDateObj = new Date(sprintInfo.endDate)
                  const [startDate] = new Date(startDateObj).toISOString().split('T')
                  const [endDate] = new Date(endDateObj).toISOString().split('T')

                  arr.push({
                    sprintName: sprintInfo.sprintName,
                    startDate,
                    endDate,
                    value
                  })
                }

                break
              }
              default: break
            }
          }

          return arr
        }, []).reverse()
      }
    }

    return obj
  }, {})

  return dissectedInfo
}

const googleSlice = createSlice({
  name: 'google',
  initialState: {
    billingInfo: {},
    trackerInfo: {},
    ticketsInfo: {},
    loading: false,
    fetchedAt: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpreadsheet.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchSpreadsheet.fulfilled, (state, action) => {
        state.loading = false
        state.billingInfo = action.payload.billingInfo
        state.trackerInfo = action.payload.trackerInfo
        state.ticketsInfo = action.payload.ticketsInfo
        state.fetchedAt = Date.now()
      })
      .addCase(fetchSpreadsheet.rejected, (state) => {
        state.loading = false
      })
  }
})

export const actions = { fetchSpreadsheet }
export const { reducer } = googleSlice
